import moment from 'moment';

export default class DeadlineCalculatedHelper {
    static getDeadlineCalculated(step, calendarTimelineStepState) {
        let deadlineCalculated = null;

        if (step.isConstant) {
            let base = null;

            switch (step.deadline.base) {
                case 'contractAcceptanceDate':
                    base = calendarTimelineStepState.data.contractAcceptanceDate;
                    break;
                case 'closeOfEscsrow': {
                    const closeOfEscrowEvent = calendarTimelineStepState.data.timeline.find(
                        event => event.eventType === 'scheduled-close-of-escrow'
                    );
                    if (closeOfEscrowEvent) {
                        base = closeOfEscrowEvent.deadlineCalculated;
                    }
                    break;
                }
                default:
            }

            if (base) {
                deadlineCalculated = moment(base)
                    .add(step.deadline.offset, 'days')
                    .toJSON();
            }
        } else if (calendarTimelineStepState.data.timeline) {
            const timeline = calendarTimelineStepState.data.timeline.find(event => event.eventType === step.type);

            if (timeline) {
                deadlineCalculated = timeline.deadlineCalculated;
            }
        }

        return deadlineCalculated;
    }
}



// WEBPACK FOOTER //
// ./src/utils/deadline-calculated-helper.js